export const isRunningInOperaBrowser = () => window.ethereum?.isOpera;

export const isRunningInBinanceChainWallet = () => !!window.BinanceChain;
